import React from "react";

import { SubHeading, MenuItem } from "../../components";
import { data } from "../../constants";
import "./SpecialMenu.css";

const SpecialMenu = () => (
  <div className="app__specialMenu flex__center section__padding" id="menu">
    <div className="app__specialMenu-title">
      <h1 className="headtext__cormorant">Pho Ha Long Menu</h1>
      <SubHeading title="*additional $1 Charge for takeout" />
    </div>

    <div className="app__specialMenu-menu_item_category flex__center" id="pho">
      <p className="app__specialMenu-menu_heading">Pho</p>
      <div className="app__specialMenu_menu_items">
        {data.pho.map((pho, index) => (
          <MenuItem
            key={pho.title + index}
            title={pho.title}
            price={pho.price}
            tags={pho.tags}
          />
        ))}
      </div>
    </div>

    <div
      className="app__specialMenu-menu_item_category  flex__center"
      id="appetizer"
    >
      <p className="app__specialMenu-menu_heading">Appetizer</p>
      <div className="app__specialMenu_menu_items">
        {data.appetizer.map((appetizer, index) => (
          <MenuItem
            key={appetizer.title + index}
            title={appetizer.title}
            price={appetizer.price}
            tags={appetizer.tags}
          />
        ))}
      </div>
    </div>

    <div
      className="app__specialMenu-menu_item_category  flex__center"
      id="vermicelli"
    >
      <p className="app__specialMenu-menu_heading">Vermicelli or Rice</p>
      <div className="app__specialMenu_menu_items">
        {data.vermicelli.map((vermicelli, index) => (
          <MenuItem
            key={vermicelli.title + index}
            title={vermicelli.title}
            price={vermicelli.price}
            tags={vermicelli.tags}
          />
        ))}
      </div>
    </div>

    <div
      className="app__specialMenu-menu_item_category  flex__center"
      id="lomein"
    >
      <p className="app__specialMenu-menu_heading">Lo Mein Noodle</p>
      <div className="app__specialMenu_menu_items">
        {data.lomein.map((lomein, index) => (
          <MenuItem
            key={lomein.title + index}
            title={lomein.title}
            price={lomein.price}
            tags={lomein.tags}
          />
        ))}
      </div>
    </div>

    <div
      className="app__specialMenu-menu_item_category  flex__center"
      id="rice_and_noodle"
    >
      <p className="app__specialMenu-menu_heading">
        Fried Rice or Stir Fry Noodle
      </p>
      <div className="app__specialMenu_menu_items">
        {data.rice_and_noodle.map((rice_and_noodle, index) => (
          <MenuItem
            key={rice_and_noodle.title + index}
            title={rice_and_noodle.title}
            price={rice_and_noodle.price}
            tags={rice_and_noodle.tags}
          />
        ))}
      </div>
    </div>

    <div
      className="app__specialMenu-menu_item_category  flex__center"
      id="kids"
    >
      <p className="app__specialMenu-menu_heading">Kids Meal</p>
      <p className="app__specialMenu-menu_subheading">Serve Under Age 12 </p>
      <div className="app__specialMenu_menu_items">
        {data.kids.map((kids, index) => (
          <MenuItem
            key={kids.title + index}
            title={kids.title}
            price={kids.price}
            tags={kids.tags}
          />
        ))}
      </div>
    </div>

    <div
      className="app__specialMenu-menu_item_category  flex__center"
      id="beverages"
    >
      <p className="app__specialMenu-menu_heading">Beverages</p>
      <div className="app__specialMenu_menu_items">
        {data.beverages.map((beverages, index) => (
          <MenuItem
            key={beverages.title + index}
            title={beverages.title}
            price={beverages.price}
            tags={beverages.tags}
          />
        ))}
      </div>
    </div>

    <div className="app__specialMenu-menu_item_category  flex__center">
      <p className="app__specialMenu-menu_heading">Boba Tea</p>
      <p className="app__specialMenu-menu_subheading">
        All $7.50 | $8 for mix of 2 flavors{" "}
      </p>
      <div className="app__specialMenu_menu_items">
        {data.boba.map((boba, index) => (
          <MenuItem
            key={boba.title + index}
            title={boba.title}
            price={boba.price}
            tags={boba.tags}
          />
        ))}
      </div>
    </div>
  </div>
);

export default SpecialMenu;
